import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Stepper,
  Step,
  StepButton,
  Typography,
  Button,
  Paper,
  TextField,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControl,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormHelperText,
} from "@material-ui/core";
import * as React from "react";
import logoIcon from "../assets/images/logo_3.png";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import ButtonComponent from "../components/ButtonComponent";
import { isNullOrUndefined } from "util";
import { AuthenticationService } from "../services/AuthenticationService";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    button: {
      marginRight: theme.spacing(1),
      backgroundColor: "#f96500",
    },
    completed: {
      display: "inline-block",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  });
interface Props extends WithStyles<typeof styles> {
  onLogin: any;
}
class ForgotPasswordScreen extends React.Component<Props> {
  state = {
    activeStep: 0,
    steps: [],
    showPassword: false,
    showConfirmPassword: false,
    error: "",
    openErrorDialog: false,
    email: "",
    code: "",
    password: "",
    confirmPassword: "",

    passwordLengthError: "",
  };

  componentDidMount = () => {
    this.setState({
      steps: this.getSteps(),
    });
  };

  getSteps = () => {
    return [
      "Enter email address",
      "Verification",
      "Reset password",
      "Completed",
    ];
  };

  onShowPassword = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };
  onShowConfirmPassword = () => {
    this.setState({
      showConfirmPassword: !this.state.showConfirmPassword,
    });
  };
  handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };

  handleEmailChanged = (event: any) => {
    this.setState({
      email: event.target.value,
    });
  };

  handleCodeChanged = (event: any) => {
    this.setState({
      code: event.target.value,
    });
  };

  handlePasswordChanged = (event: any) => {
    if (event.target.value.length < 6) {
      this.setState({
        passwordLengthError: "Password must be at least 6 characters",
      });
    } else {
      this.setState({
        password: event.target.value,
        passwordLengthError: "",
      });
    }
  };
  handleConfirmPasswordChanged = (event: any) => {
    this.setState({
      confirmPassword: event.target.value,
    });
  };

  getStepContent = (step: any) => {
    switch (step) {
      case 0:
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              height: "100%",
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <Typography>
              Please enter your email address to search for your account.
            </Typography>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <TextField
                style={{
                  width: "80%",
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 10,
                }}
                id={"email"}
                value={this.state.email}
                onChange={(event: any) => this.handleEmailChanged(event)}
                type={"email"}
                variant="outlined"
                name={"email"}
                label={"Email"}
                fullWidth
              // error={errors.email ? true : false}
              // helperText={errors.email}
              />
            </div>
          </div>
        );
      case 1:
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              height: "100%",
              flexDirection: "column",
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <Typography>
              Please enter the code sent to your email address to verify
              account.
            </Typography>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <TextField
                style={{
                  width: "80%",
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 10,
                }}
                id={"code"}
                value={this.state.code}
                onChange={(event: any) => this.handleCodeChanged(event)}
                type={"number"}
                variant="outlined"
                name={"code"}
                label={"Verification code"}
                fullWidth
              // error={errors.code ? true : false}
              // helperText={errors.code}
              />
            </div>
          </div>
        );
      case 2:
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              height: "100%",
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <Typography>Please enter your new password and confirm.</Typography>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <FormControl
                style={{
                  width: "80%",
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 10,
                }}
                variant="outlined"
              >
                <OutlinedInput
                  id="password"
                  type={!this.state.showPassword ? "password" : "text"}
                  onChange={(event: any) => this.handlePasswordChanged(event)}
                  placeholder={"Password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => this.onShowPassword()}
                        onMouseDown={(event: any) =>
                          this.handleMouseDownPassword(event)
                        }
                      >
                        {!this.state.showPassword ? (
                          <Visibility />
                        ) : (
                            <VisibilityOff />
                          )}
                      </IconButton>
                    </InputAdornment>
                  }
                  labelWidth={0}
                  error={this.state.passwordLengthError ? true : false}
                />
                {this.state.passwordLengthError && (
                  <FormHelperText>
                    {this.state.passwordLengthError}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl
                style={{
                  width: "80%",
                  marginTop: 10,
                  marginBottom: 10,
                  marginLeft: 10,
                }}
                variant="outlined"
              >
                <OutlinedInput
                  id="confirmPassword"
                  type={!this.state.showConfirmPassword ? "password" : "text"}
                  onChange={(event: any) =>
                    this.handleConfirmPasswordChanged(event)
                  }
                  placeholder={"Confirm password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => this.onShowConfirmPassword()}
                        onMouseDown={(event: any) =>
                          this.handleMouseDownPassword(event)
                        }
                      >
                        {!this.state.showPassword ? (
                          <Visibility />
                        ) : (
                            <VisibilityOff />
                          )}
                      </IconButton>
                    </InputAdornment>
                  }
                  labelWidth={0}
                />
                {this.state.password !== this.state.confirmPassword && (
                  <FormHelperText>{"Password do not match."}</FormHelperText>
                )}
              </FormControl>
            </div>
          </div>
        );
      case 3:
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              height: "100%",
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <Typography>
              Your password was reset successfully. Please login.
            </Typography>
          </div>
        );
      default:
        return "Unknown step";
    }
  };

  totalSteps = () => {
    return this.state.steps.length;
  };
  isLastStep = () => {
    return this.state.activeStep === this.totalSteps() - 1;
  };

  resetPassword = () => {
    console.log("reset password");
  };
  handleNext = () => {
    const newActiveStep = this.isLastStep()
      ? this.resetPassword()
      : this.state.activeStep + 1;
    if (newActiveStep < this.state.steps.length) {
      //   this.setState({ activeStep: newActiveStep }, () => {
      this.handleStepRequest();
      //   });
    }
  };
  handleClose = () => {
    this.setState({
      openErrorDialog: false,
    });
  };
  showErrorDialog = () => {
    return (
      <Dialog
        open={this.state.openErrorDialog}
        onClose={() => this.handleClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Oops!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {this.state.error}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.handleClose()} color="primary" autoFocus>
            Try again
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  handleStepRequest = () => {
    let email = this.state.email;
    switch (this.state.activeStep) {
      case 0:
        if (!isNullOrUndefined(email)) {
          let authenticationService: AuthenticationService = new AuthenticationService();
          let jsonBody = {
            email: email,
          };
          authenticationService.retrieve(jsonBody).then((resp) => {
            EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
            if (resp && resp.success && resp.success === true) {
              this.setState({
                activeStep: 1,
              });
            } else {
              this.setState({
                openErrorDialog: true,
                error:
                  "Your search did not return any results.Please try again with other information.",
              });
            }
            if (resp && resp.error) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                type: SNACKBAR_TYPE.ERROR,
                show: true,
                message: resp.error,
              });
            }
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                type: SNACKBAR_TYPE.ERROR,
                show: true,
                message: resp.message,
              });
            }
          });
        }
        break;
      case 1:
        let code = this.state.code;
        if (!isNullOrUndefined(code)) {
          let authenticationService: AuthenticationService = new AuthenticationService();
          let jsonBody = {
            email: email,
            code: code,
          };
          authenticationService.verify(jsonBody).then((resp) => {
            EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
            if (resp && resp.success && resp.success === true) {
              this.setState({
                activeStep: 2,
              });
            } else {
              this.setState({
                openErrorDialog: true,
                error:
                  "Your search did not return any results.Please try again with other information.",
              });
            }
            if (resp && resp.error) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                type: SNACKBAR_TYPE.ERROR,
                show: true,
                message: resp.error,
              });
            }
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                type: SNACKBAR_TYPE.ERROR,
                show: true,
                message: resp.message,
              });
            }
          });
        }
        break;
      case 2:
        let password = this.state.password;
        let confirmPassword = this.state.confirmPassword;
        if (
          !isNullOrUndefined(password) &&
          !isNullOrUndefined(confirmPassword)
        ) {
          if (password === confirmPassword) {
            let authenticationService: AuthenticationService = new AuthenticationService();
            let jsonBody = {
              email: email,
              password: password,
            };
            authenticationService.reset(jsonBody).then((resp) => {
              EventEmitter.dispatch(
                EventEmitter.events.STOP_LOADING_REQUEST,
                {}
              );
              if (resp && resp.success && resp.success === true) {
                this.setState({
                  activeStep: 3,
                });
              } else {
                this.setState({
                  openErrorDialog: true,
                  error:
                    "Password reset failed.Please try again or contact administractor.",
                });
              }
              if (resp && resp.error) {
                EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                  type: SNACKBAR_TYPE.ERROR,
                  show: true,
                  message: resp.error,
                });
              }
              if (resp && resp.message) {
                EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                  type: SNACKBAR_TYPE.ERROR,
                  show: true,
                  message: resp.message,
                });
              }
            });
          } else {
            this.setState({
              openErrorDialog: true,
              error: "Your passwords do not match. Please try again",
            });
          }
        }
        break;
      default:
        break;
    }
  };

  handleBack = () => {
    this.setState((state: any) => {
      return { activeStep: state.activeStep - 1 };
    });
  };

  handleStep = (step: any) => () => {
    this.setState({
      activeStep: step,
    });
  };

  handleReset = () => {
    this.setState({ activeStep: 0 });
  };

  render() {
    const { classes, onLogin } = this.props;
    return (
      <React.Fragment>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            alignItems: "center",
          }}
        >
          {this.showErrorDialog()}
          <Paper
            style={{
              height: "100vh",
              display: "flex",
              width: "100%",
              padding: 20,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Paper
              style={{
                width: "40%",
                height: "100%",
                borderTopLeftRadius: 10,
                borderBottomLeftRadius: 10,
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "30%",
                    margin: "10%",
                    justifyContent: "flex-end",
                  }}
                >
                  <img
                    src={logoIcon}
                    width={"100%"}
                    height={"50%"}
                    color={"red"}
                    alt="SEGPI"
                  />
                  <Typography
                    variant={"h2"}
                    display={"block"}
                    style={{
                      fontSize: 24,
                      padding: 10,
                      textAlign: "center",
                    }}
                  >
                    Paperless Application
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 0.2,
                    justifyContent: "flex-end",
                  }}
                ></div>
              </div>
            </Paper>
            <Paper
              style={{
                width: "60%",
                height: "100%",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                backgroundColor: "white",
              }}
            >
              <Typography
                variant={"h2"}
                style={{
                  fontSize: 32,
                  padding: 10,
                }}
              >
                Find your account
              </Typography>

              <div className={classes.root}>
                <Stepper nonLinear activeStep={this.state.activeStep}>
                  {this.state.steps.map((label, index) => (
                    <Step key={label}>
                      <StepButton
                        onClick={this.handleStep(index)}
                        completed={this.state.activeStep > index}
                      >
                        {label}
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
                <div>
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "column",
                    }}
                  >
                    {this.getStepContent(this.state.activeStep)}
                    {this.state.activeStep < this.state.steps.length - 1 && (
                      <div
                        style={{
                          marginLeft: "10%",
                          marginRight: "10%",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          disabled={this.state.activeStep === 0}
                          style={{
                            backgroundColor:
                              this.state.activeStep === 0 ? "white" : "#f96500",
                            color:
                              this.state.activeStep === 0 ? "grey" : "white",
                          }}
                          onClick={this.handleBack}
                          className={classes.button}
                        >
                          Back
                        </Button>
                        {this.state.activeStep < this.totalSteps() - 1 ? (
                          <Button
                            variant="contained"
                            type={"submit"}
                            style={{
                              backgroundColor: "#f96500",
                              color: "white",
                            }}
                            onClick={this.handleNext}
                            className={classes.button}
                          >
                            Next
                          </Button>
                        ) : (
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "#f96500",
                                color: "white",
                              }}
                              onClick={this.handleNext}
                            >
                              Finish
                            </Button>
                          )}
                      </div>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    marginBottom: 0,
                    height: "100%",
                    width: "100%",
                    flexDirection: "column",
                    justifyContent: "space-evenly",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {this.state.activeStep < this.state.steps.length - 1 && (
                    <div>
                      <Typography>OR</Typography>
                      <Divider
                        style={{
                          height: 2,
                          width: "80%",
                        }}
                      />
                    </div>
                  )}
                  <div
                    style={{
                      height: 55,
                      width: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <ButtonComponent text={"LOGIN"} onClick={onLogin}>
                      Finish
                    </ButtonComponent>
                  </div>
                </div>
              </div>
            </Paper>
          </Paper>
        </div>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ForgotPasswordScreen);
